module.exports = __webpack_public_path__ + "img/94.22dffb1f.png";